module.exports = ''
+ '<div id="creek-audio-toolbar">'
// '<div id="creek-audio-toolbar" class="creek-audio-toolbar-container">'
+'  <div class="creek-audio-toolbar-inner">'
+'    <a class="creek-audio-main-button creek-audio-play-button" href="javascript:">'
+'      <span class="fa-stack fa-lg">'
// +'        <i class="fa fa-circle fa-stack-2x"></i>'
+'        <i class="creek-audio-play-icon fa fa-play fa-stack-1x"></i><i class="creek-audio-pause-icon fa fa-pause fa-stack-1x"></i><i class="creek-audio-loading-icon fa fa-circle-o-notch fa-stack-1x fa-spin"></i>'
+'      </span>'
+'    </a>'
+'    <a class="creek-audio-show-image creek-persist-link"><img src="" /></a>'
+'    <a href="javascript:" class="creek-audio-volume-button creek-audio-volume-button-open"><i class="fa fa-volume-up"></i></a>'
+'    <a href="javascript:" class="creek-audio-volume-button creek-audio-volume-button-close"><i class="fa fa-volume-up"></i></a>'
+'    <div class="creek-live-data">'
+'      <a class="creek-audio-switch-to-live creek-hide" href="javascript:">Back to live</a>'
+'      <div class="creek-show-title-container"><a class="creek-show-title creek-show-link creek-audio-title creek-audio-link creek-persist-link" href="/shows/"></a></div>'
+'      <div class="creek-show-time" style="display:none;">'
+'        <span class="start"></span> - '
+'        <span class="end"></span>'
+'      </div>'
+'      <div class="creek-track" style="display:none;"><a href="javascript:" class="creek-persist-link creek-broadcast-link"><div class="creek-track-album-art"></div><span class="creek-track-artist"></span> - <span class="creek-track-title"></span></a> &nbsp; </div>'
+'      <div class="creek-track-none">&nbsp;</div>'
+'    </div>'
+'    <div id="creek-audio-volume-tool" style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;" unselectable="on" onselectstart="return false;">'
+'      <div class="bar">'
+'        <div class="filler"></div>'
+'      </div>'
+'    </div>'
+'  </div>'
+'</div>'



// WEBPACK FOOTER //
// ./src/templates/audio-toolbar.js